import { ElementTypeV2 } from "@generated/UseNodeLogic_NodeFragment.graphql";

export const elementTypeToNextButtonText = (
	elementType: readonly ElementTypeV2[] | undefined,
): string => {
	if (elementType?.includes("file")) {
		return "ZUM THEMENHEFT";
	} else if (elementType?.includes("multipleChoice")) {
		return "ZUR LERNERFOLGSKONTROLLE";
	} else if (elementType?.includes("podcast")) {
		return "ZUM PODCAST";
	} else if (elementType?.includes("text")) {
		return "MEHR DETAILS";
	} else if (elementType?.includes("video")) {
		return "ZUM VIDEO";
	} else {
		return "ZUM NÄCHSTEN MODUL";
	}
};
